import { Component, OnInit, Input, OnChanges, SimpleChanges, NgZone, ViewChild, OnDestroy } from '@angular/core';
import { GoogleChartService } from '../services/google-chart.service';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { ConsumptionHist } from '../Models/MeterModel';
import { DatePipe } from '@angular/common';
import { MinMaxDate } from '../Models/MiscModels';
import { MeterService } from '../services/meter.service';
import { SignalrISOdataService } from '../services/signalr-ISOdata.service';
import { MiscService } from '../services/misc.service';
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
import { ResizedEvent } from 'angular-resize-event';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-year-hist-chart',
  templateUrl: './year-hist-chart.component.html',
  styleUrls: ['./year-hist-chart.component.css']
})
export class YearHistChartComponent implements OnInit, ViewChild, OnDestroy {

  public destroyed = new Subject<any>();

  private minMaxDate: MinMaxDate;
  private YearHistTable: any;
  private YearHistDashboard: any;
  private chartTitle: string;

  private YearHistDateSlider: any;
  private width: number;
  private height: number;
  private controlOptions: any;
  public btnLabel = 'Show as Table';
  private YearHistLine;
  constructor(private gChartService: GoogleChartService, private route: ActivatedRoute, private ngZone: NgZone) {

  }
  descendants: boolean;
  first: boolean;
  read: any;
  isViewQuery: boolean;
  selector: any;
  static?: boolean;


  private chartDataYr = new Array<ConsumptionHist>();
  private chartDataSummer = new Array<ConsumptionHist>();
  private chartDataNonSummer = new Array<ConsumptionHist>();

  private options = {
    enableInteractivity: true,

    seriesType: 'scatter',
    series: {
      0: { color: 'grey' },
      1: { color: 'red' },
      2: { color: '#13f9f6' },
    },
    orientation: 'vertical',
    legend: {
      position: 'top', alignment: 'end'
    },

    pointsVisible: true,
    titleTextStyle: {
      color: 'black',    // any HTML string color ('red', '#cc00cc')
      fontName: 'Montesserat', // i.e. 'Times New Roman'
      fontSize: '24', // 12, 18 whatever you want (don't specify px)
      bold: false,    // true or false
      italic: true,   // true of false
    },
    chartArea: { width: '80%', height: '80%' },
    crosshair: { trigger: 'both' },
    curveType: 'function',
    lineWidth: 2,

    // vAxis: { title: 'KW', textStyle: { fontSize: '12' }, format: '#,### KW', textPosition:'out' },
    vAxis: {
      title: 'Consumption Load',
      textStyle: {
        color: '#1a237e',
        fontSize: 14,

      },
      format: '#,### KW',
      titleTextStyle: {
        color: '#1a237e',
        fontSize: 18,
        bold: false,
      }
    },

    hAxis: {
      title: 'Percentile',
      textStyle: {
        fontSize: '14'
      },
      format: 'percent',
      gridlines: {
        count: -1,

      },
      minorGridlines: {

      },
      maxValue: 1,
      minValue: 0,
    },

  };
  setFilterOptions() {
    this.controlOptions = {

      'filterColumnIndex': 1,
      ui: {
        'chartOptions': {
          vAxis: { textStyle: { fontSize: '12' }, format: '#,### KW', textPosition: 'out' },
          orientation: 'vertical',
          chartArea: { width: '80%', height: '90%' },
          hAxis: {
            format: 'percent',
            textStyle: {
              fontSize: '12'
            },
            gridlines: {
              count: -1,

            },
            minorGridlines: {

            },


          }
        },
      }

    };
  }

  ngOnInit() {
    const google = this.gChartService.getGoogle();
    google.charts.load('current', { 'packages': ['corechart', 'table', 'controls'] });
    google.charts.setOnLoadCallback(this.drawYearHistChart.bind(this));
    this.route.params.pipe(
      takeUntil(this.destroyed)
    ).subscribe(val => {
      this.chartDataYr = this.route.snapshot.data.yearHistData;
      this.chartDataSummer = this.route.snapshot.data.summerHistData;
      this.chartDataNonSummer = this.route.snapshot.data.nonSummerHistData;
    });



  }
  formatAxes(YearHistTable) {
    const google = this.gChartService.getGoogle();
    const formatterKW = new google.visualization.NumberFormat({ suffix: ' KW', pattern: '#,###' });
    formatterKW.format(YearHistTable, 0); // Apply formatter to second column

    const formatterPercent = new google.visualization.NumberFormat({ pattern: 'percent' });
    formatterPercent.format(YearHistTable, 1); // Apply formatter to second column
    formatterPercent.format(YearHistTable, 2); // Apply formatter to second column
    formatterPercent.format(YearHistTable, 3); // Apply formatter to second column
  }

  private drawYearHistChart(options) {
    const google = this.gChartService.getGoogle();
    // Create the dataset (DataTable)
    this.YearHistTable = new google.visualization.DataTable();
    this.YearHistTable.addColumn('number', 'KW');
    this.YearHistTable.addColumn('number', 'Complete Year');
    this.YearHistTable.addColumn('number', 'Summer Months(June-Sep)');
    this.YearHistTable.addColumn('number', 'All except Summer Months');

    for (let i = 0; i < this.chartDataYr.length; i++) {
      const chartRow = new Array<number>();

      if (this.chartDataYr[i].kw === 0) {
        this.chartDataYr[i].kw = null;
      }

      chartRow.push(this.chartDataYr[i].kw);

      chartRow.push(this.chartDataYr[i].percentile);

      chartRow.push(this.chartDataSummer[i].percentile);
      chartRow.push(this.chartDataNonSummer[i].percentile);

      this.YearHistTable.addRow(chartRow);
    }
    this.chartTitle = 'Load Curve: Consumption Load (KW) versus Cumulative Perecentile';


    // Create a dashboard.
    const dash_container = document.getElementById('YearHistdashboard_div');

    this.YearHistDashboard = new google.visualization.Dashboard(dash_container);

    // Create a date range slider
    this.YearHistDateSlider = new google.visualization.ControlWrapper({
      'controlType': 'ChartRangeFilter',
      'containerId': 'YearHistcontrol_div',
      'state': { 'range': { 'start': 0, 'end': 38 } }
    });
    this.setFilterOptions();
    this.YearHistDateSlider.setOptions(this.controlOptions);

    this.formatAxes(this.YearHistTable);

    // Line chart visualization
    this.YearHistLine = new google.visualization.ChartWrapper({
      'chartType': 'ComboChart',
      'containerId': 'YearHistline_div',

      'options': this.options,
    });

    this.YearHistLine.setOption('title', this.chartTitle);
    // Bind YearHistLine to the dashboard, and to the controls
    // this will make sure our line chart is updated when our date changes
    this.YearHistDashboard.bind(this.YearHistDateSlider, this.YearHistLine);

    this.YearHistDashboard.draw(this.YearHistTable);

  }

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;


    console.log('width', this.width);
    console.log('height', this.height);

    if (this.YearHistDashboard !== undefined) {
      this.YearHistDashboard.draw();
      this.YearHistDateSlider.draw();
    }
  }
  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }


private switchChart() {

  let chartType;
  const google = this.gChartService.getGoogle();
  const view = new google.visualization.DataView(this.YearHistTable);

  // view.hideColumns([4, 5]);
  // tslint:disable-next-line:triple-equals
  if (this.btnLabel == 'Show as Chart') {
    chartType = 'ComboChart';
    this.YearHistLine.setChartType(chartType);
    this.btnLabel = 'Show as Table';
  } else {
    chartType = 'Table';
    this.YearHistLine.setChartType(chartType);
    this.btnLabel = 'Show as Chart';

  }
  const ChartType = this.YearHistLine.getChartType();

  //const options = this.getOptions(chartType);
  this.YearHistLine.setOptions(this.options);
  this.YearHistLine.setOption('title', this.chartTitle);
  if (chartType === 'Table') {
    this.YearHistDashboard.draw(view, { sortColumn: 0 });
  } else {
    this.YearHistDashboard.draw(this.YearHistTable);
  }
}

}

